/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormRename
 */
export interface FormRename {
    /**
     * 
     * @type {string}
     * @memberof FormRename
     */
    name: string;
}

export function FormRenameFromJSON(json: any): FormRename {
    return FormRenameFromJSONTyped(json, false);
}

export function FormRenameFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormRename {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function FormRenameToJSON(value?: FormRename | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


